import { render } from "./RegelsatzStatusLabel.pug?vue&type=template&id=374826bf&lang=pug"
import script from "./RegelsatzStatusLabel.js?vue&type=script&lang=js"
export * from "./RegelsatzStatusLabel.js?vue&type=script&lang=js"

import exportComponent from "/var/lib/jenkins/workspace/rel_build_mdm/frontend/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__